<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        type="primary"
        @click="showQrCode"
        size="small"
        >邀请二维码</el-button
      >
      <el-input
        v-model="listQuery.id"
        placeholder="ID"
        style="width: 200px"
        class="filter-item"
        clearable
        size="small"
      />
      <el-input
        v-model="listQuery.name"
        placeholder="姓名"
        style="width: 200px"
        class="filter-item"
        clearable
        size="small"
      />

      <el-select
        v-model="listQuery.gender"
        placeholder="性别"
        clearable
        style="width: 200px"
        class="filter-item"
        size="small"
      >
        <el-option label="男" value="1" />
        <el-option label="女" value="2" />
      </el-select>
      <el-select
        v-model="listQuery.department_id"
        placeholder="部门"
        clearable
        style="width: 200px"
        class="filter-item"
        size="small"
      >
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in departmentList"
          :key="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.job_id"
        placeholder="职级"
        clearable
        style="width: 200px"
        class="filter-item"
        size="small"
      >
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in jobList"
          :key="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        clearable
        style="width: 200px"
        class="filter-item"
        size="small"
      >
        <el-option label="正常" value="normal" />
        <el-option label="已离职" value="freeze" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索</el-button
      >
    </div>
    <div class="filter-container">
      <span class="filter-item" style="margin-right: 20px"
        >企业号：{{ enterprise }}</span
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="copy(enterprise)"
        size="small"
        >复制</el-button
      >
    </div>
    <el-table
      size="small"
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="ID" width="120">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="姓名" width="120">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="性别" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.gender === 1" type="warning"> 男 </el-tag>
          <el-tag v-else type="success">女</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="部门" width="120">
        <template slot-scope="scope">
          {{ scope.row.department?.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="工号" width="120">
        <template slot-scope="scope">
          {{ scope.row.employee_no || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="职级" width="120">
        <template slot-scope="scope">
          {{ scope.row.job?.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="上级领导" width="120">
        <template slot-scope="scope">
          {{ scope.row.superior_leader }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="企业邮箱" width="120">
        <template slot-scope="scope">
          {{ scope.row.enterprise_email }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="证件号码" width="120">
        <template slot-scope="scope">
          {{ scope.row.id_number }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'normal'" type="success">
            正常
          </el-tag>
          <el-tag v-else type="warning">已离职</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <el-button
            v-if="scope.row.status === 'normal'"
            size="mini"
            type="warning"
            @click="changeStatus(scope.row.id, 'resignation')"
            >离职</el-button
          >
          <el-button
            v-else
            size="mini"
            type="success"
            @click="changeStatus(scope.row.id, 'normal')"
            >复职</el-button
          >
          <!--          <el-button size="mini" type="danger" @click="handleDel(scope.row.id)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-select
            v-model="form.gender"
            placeholder="性别"
            clearable
            style="width: 200px"
            class="filter-item"
            size="small"
          >
            <el-option label="男" :value="1" />
            <el-option label="女" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="department_id">
          <el-select
            v-model="form.department_id"
            placeholder="部门"
            clearable
            style="width: 200px"
            class="filter-item"
            size="small"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in departmentList"
              :key="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="工号" prop="employee_no">
          <el-input v-model="form.employee_no" />
        </el-form-item>
        <el-form-item label="职级" prop="job_id">
          <el-select
            v-model="form.job_id"
            placeholder="职级"
            clearable
            style="width: 200px"
            class="filter-item"
            size="small"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in jobList"
              :key="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="上级领导" prop="superior_leader">
          <el-input v-model="form.superior_leader" />
        </el-form-item>
        <el-form-item label="企业邮箱" prop="enterprise_email">
          <el-input v-model="form.enterprise_email" />
        </el-form-item>
        <el-form-item label="证件号码" prop="id_number">
          <el-input v-model="form.id_number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 弹窗显示二维码 -->
    <!-- <el-dialog title="邀请二维码" :visible.sync="qrCodeVisible" width="300px">
      <div style="text-align: center">
        <img
          :src="qrCodeUrl"
          alt="二维码"
          style="width: 200px; height: 200px"
        />
      </div>
      <el-row type="flex" justify="center" style="margin-top: 20px">
        <el-button type="primary" @click="downloadQrCode">下载二维码</el-button>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrCodeVisible = false">关闭</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      :visible.sync="qrCodeVisible"
      width="600px"
      :show-close="false"
      id="downloadcode"
    >
      <div class="download">
        <img
          src="@/assets/close.png"
          alt=""
          class="download-close"
          @click="qrCodeVisible = false"
        />
        <div class="download-title">邀请二维码</div>
        <div style="text-align: center" class="download-codebox">
          <img
            :src="qrCodeUrl"
            alt="二维码"
            style="width: 420px; height: 420px"
          />
        </div>
        <div class="download-name">{{ info.user?.full_name ?? '' }}</div>
        <div type="primary" @click="downloadQrCode" class="download-btn">
          下载
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getInfo } from '@/api/login'
import html2canvas from 'html2canvas'
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      info: {},
      dialogPvVisible: false,
      pvData: [],
      jobList: [],
      departmentList: [],
      form: {
        id: '',
        name: '',
        permissions: [],
      },
      rules: {
        name: [{ required: true, message: '姓名不能为空', trigger: 'change' }],
        gender: [
          { required: true, message: '性别不能为空', trigger: 'change' },
        ],
        department_id: [
          { required: true, message: '部门不能为空', trigger: 'change' },
        ],
      },
      //权限复选框
      checkAll: false,
      isIndeterminate: false,
      permissions: [],
      btnLoading: false,
      qrCodeVisible: false,
      qrCodeUrl: '',
      enterprise: '',
    }
  },
  created() {
    getInfo().then((res) => {
      this.info = res.data
    })
    this.getEnterprise()
    this.getJobList()
    this.getDepartmentList()
    this.getList()
  },
  methods: {
    changeStatus(id, status) {
      this.$confirm('是否确认操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/memberend/employee/changeStatus',
            method: 'post',
            data: { id: id, status: status },
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    copy(text) {
      navigator.clipboard.writeText(text).then(
        () => {
          this.$message({
            message: '复制成功',
            type: 'success',
          })
        },
        () => {
          this.$message({
            message: '复制失败',
            type: 'error',
          })
        }
      )
    },
    async downloadQrCode() {
      // 获取弹窗内容节点
      const dialog = document.querySelector('.el-dialog__body')
      if (!dialog) return

      // 使用 html2canvas 生成图片
      html2canvas(dialog, {
        backgroundColor: null,
        useCORS: true,
      }).then((canvas) => {
        const link = document.createElement('a')
        link.href = canvas.toDataURL('image/png')
        link.download = '邀请二维码.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    showQrCode() {
      // 假设你从后端拿到一个二维码图片地址
      this.qrCodeUrl =
        'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' +
        this.enterprise
      this.qrCodeVisible = true
    },
    getJobList() {
      request({
        url: '/api/memberend/job/list',
        method: 'get',
        params: { limit: 999999999, weight_sort: 'asc' },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.jobList = res.data.data
        }
      })
    },
    getEnterprise() {
      request({
        url: '/api/memberend/member/get-enterprise',
        method: 'get',
        params: {},
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.enterprise = res.data.enterprise
        }
      })
    },
    getDepartmentList() {
      request({
        url: '/api/memberend/department/list',
        method: 'get',
        params: { limit: 999999999, weight_sort: 'asc' },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.departmentList = res.data.data
        }
      })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/memberend/employee/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    getPermissionAll() {
      request({
        url: '/api/backend/permission/all',
        method: 'get',
        params: {},
      }).then((response) => {
        this.permissions = response.data
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    resetForm() {
      this.form = {
        id: '',
        name: '',
      }
      this.checkAll = false
      this.isIndeterminate = false
      this.btnLoading = false
    },

    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      let form = Object.assign({}, row) // copy obj
      this.form = form
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/memberend/employee/store',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    handleDelete(row) {
      this.$notify({
        title: '成功',
        message: '删除成功',
        type: 'success',
        duration: 2000,
      })
      const index = this.list.indexOf(row)
      this.list.splice(index, 1)
    },
    handleCheckAllChange(val) {
      let checkedPermissions = []
      if (val) {
        for (let i = 0; i < this.permissions.length; i++) {
          checkedPermissions.push(this.permissions[i].id)
        }
      }
      this.form.permissions = checkedPermissions
      this.isIndeterminate = false
    },
    handleCheckedPermissionsChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.permissions.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.permissions.length
    },
    handleDel(val) {
      this.$confirm('此操作将删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/role/del',
            method: 'get',
            params: { id: val },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
::v-deep #downloadcode .el-dialog {
  border-radius: 8px;
}
::v-deep #downloadcode .el-dialog__body {
  position: relative;
  overflow: hidden;
  background: url('../../assets/download.png') transparent no-repeat center;
  background-size: 100% 100%;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  border-radius: 4px;
  padding: 0;
  height: 782px;
}

::v-deep #downloadcode .el-dialog__header {
  padding: 0;
}
.download {
  box-sizing: border-box;
  width: 600px;
}
.download-close {
  position: absolute;
  top: 25px;
  right: 25px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.download-title {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  margin-top: 60px;
  margin-bottom: 30px;
}
.download-codebox {
  width: 450px;
  height: 450px;
  background: #ffffff;
  margin: 0 auto 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.download-btn {
  width: 450px;
  height: 54px;
  background: #ffffff;
  border-radius: 27px;
  margin: 30px auto 0;
  color: #254f9c;
  font-size: 18px;
  text-align: center;
  line-height: 54px;
  cursor: pointer;
}
.download-name {
  text-align: center;
  font-weight: bold;
  color: #fff;
  font-size: 32px;
  margin: 30px auto 0;
}
</style>
